import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import backButton from "../assets/backButton.svg";

import redmark from "../assets/redmark.svg";
import greenmark from "../assets/greenmark.svg";
import veganIcon from "../assets/veganIcon.svg";
import { handleError } from "../CommonJquery/CommonJquery";
import {
  save_onboarding,
  get_last_resturant,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
let default_restaurant_id_staff = "0";
const Onboadingstep3 = ({ resnewid,nextStep, prevStep }) => {

  default_restaurant_id_staff = resnewid;
  const [showLoader, setshowLoader] = useState(false);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [restaurantData, setrestaurantData] = useState([]);
  const restaurantOptions = [
    {
      img: greenmark,
      title: "Veg",
      description: "Restaurant will be list for veg restaurant",
    },
    {
      img: redmark,
      title: "Non Veg",
      description: "Restaurant will be list for non veg restaurant",
    },
    {
      img: veganIcon,
      title: "Vegan",
      description: "Restaurant will be listed for vegan options",
    },
  ];

  const [selectedOption, setSelectedOption] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState(
    new Array(restaurantOptions.length).fill(false)
  );

  const handleNextStep = () => {
    console.log(selectedOption);
    if (selectedOption === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select at least one option!",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      });
    } else {
      handleSaveChangesdynamic();
    }
  };

  const handleSaveChangesdynamic = async () => {
    setshowLoader(true);
    const form_data = new FormData();
    form_data.append("default_restaurant_id_staff_new", default_restaurant_id_staff);
    form_data.append("veg_non_both_type", selectedOption);
    form_data.append("step_save", "3");

    await server_post_data(save_onboarding, form_data)
      .then(async (Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          nextStep();
        }
        setshowLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setshowLoader(false);
      });
  };

  useEffect(() => {
    master_data_get();
  }, []);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const form_data = new FormData();
    form_data.append("default_restaurant_id_staff_new", default_restaurant_id_staff);
    await server_post_data(get_last_resturant, form_data)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (Response.data.message.restaurant_data.length > 0) {
            setrestaurantData(Response.data.message.restaurant_data[0]);
            
            // Get saved veg_non_both_type value
            const vegNonBothType = Response.data.message.restaurant_data[0].veg_non_both_type;
            
            // Initialize selectedOptions based on saved data
            const newSelectedOptions = [false, false, false];
            
            // Map the veg_non_both_type value to checkbox selections
            // Assuming: 0 or null = none, 1 = Veg, 2 = Non-Veg, 3 = Vegan
            if (vegNonBothType === 1 || vegNonBothType === "1") {
              newSelectedOptions[0] = true; // Veg
            } else if (vegNonBothType === 2 || vegNonBothType === "2") {
              newSelectedOptions[1] = true; // Non Veg
            } else if (vegNonBothType === 3 || vegNonBothType === "3") {
              newSelectedOptions[2] = true; // Vegan
            }
            
            setSelectedOptions(newSelectedOptions);
            setSelectedOption(vegNonBothType);
          }
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCheckboxChange = (index) => {
    const updatedSelection = new Array(restaurantOptions.length).fill(false);
    updatedSelection[index] = true;
    setSelectedOptions(updatedSelection);
    
    // Set selectedOption to index + 1 (1 for Veg, 2 for Non-Veg, 3 for Vegan)
    setSelectedOption(index + 1);
  };

  const isFormValid = selectedOptions.some((option) => option);

  return (
    <div className="mt-3">
      <div className="containerRight">
        <div className="rightHeading">
          <div className="d-flex BackHeading">
            <button onClick={prevStep}>
              <img src={backButton} alt="Back Button" />
            </button>
            <h3>Choose Your Restaurant Food Type </h3>
          </div>
          <p>Select all that apply to your Restaurant</p>
        </div>

        <div className="overflowHeight overFlowStp2">
          {restaurantOptions.map((option, index) => (
            <div key={index} className="col-sm-9 mb-3">
              <div className="box1">
                <div className="row align-items-center">
                  <div className="col-2 d-flex justify-content-center">
                    <img
                      src={option.img}
                      alt={option.title}
                      className="vegNon"
                    />
                  </div>
                  <div className="col">
                    <div className="AllContent">
                      <p>{option.title}</p>
                      <label>{option.description}</label>
                    </div>
                  </div>

                  <div className="col-2">
                    <div className="inputCHeck">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedOptions[index]}
                          onChange={() => handleCheckboxChange(index)}
                        />
                        <span className="custom-checkbox"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          <div
            className={`fixNextButton  ${
              isFormValid ? "nonEmptyBttn" : " emptyFiled"
            }`}
            style={{ marginTop: "0px" }}
          >
            <div className="container-lg d-flex justify-content-end">
              <button onClick={handleNextStep} disabled={!isFormValid}>
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Onboadingstep3;